/* Bundle breakdown. Added by Oleg @ IAKOE.
   <ts-bundle>: exclusive accordion — opening an item closes the others
   ('toggle' doesn't bubble, so it's captured). A chip click just opens the
   matching item (no scrolling). */
if (!customElements.get('ts-bundle')) {
  customElements.define(
    'ts-bundle',
    class TsBundle extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const chip = event.target.closest('[data-ts-bundle-anchor]');
          if (!chip || !this.contains(chip)) return;
          event.preventDefault();
          const target = this.querySelector(chip.getAttribute('href'));
          if (target) target.open = true;
        });

        this.addEventListener(
          'toggle',
          (event) => {
            const item = event.target;
            if (!item.matches || !item.matches('.ts-bundle__item') || !item.open) return;
            this.querySelectorAll('.ts-bundle__item[open]').forEach((other) => {
              if (other !== item) other.open = false;
            });
          },
          true
        );
      }
    }
  );
}
